import { Component, OnInit, AfterViewChecked, OnDestroy, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from '../../session-service/session.service';
import { formatDate, DatePipe } from '@angular/common';
import { Observable, of, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { ToastrService } from '@kpmg-tax/ui';
import { Engagement } from '../../models/engagement/engagement.model';
import { HomeEditAnEngagementService } from './home-edit-an-engagement.service';
import { BaseResponse } from '../../models/base-response.model';
import { Messages } from '../../constants/messages';
import { role } from '../../constants/role-enum';
import { EngagementFlagOptions, EngagementFlag } from '../../../shared/constants/engagement-flag';
import { copyObject, stringNotEmpty } from 'src/app/shared/lib/custom-tools';
// import { Options, ChangeContext } from '@angular-slider/ngx-slider';
import { StudyLandingService } from '../../../study-home/study-landing/study-landing.service';
import { CreateStudyService } from '../create-study/services/create-study.service';
import { RightSideDrawerChildComponent } from '../right-side-drawer-child.component';
import { MsalService } from '@azure/msal-angular';
import { AdminClientUsersService } from 'src/app/admin/admin-client-users/admin-client-users.service';
import { APP_CONSTANTS } from '../../constants/app-constants';
import { CustomDropDown } from '../../models/custom-dropdown.model';
import { encodeText, decodeText } from 'src/app/shared/lib/custom-tools';
import { ManageClientUserDetails } from '../../models/user-client/manage-clientuser-details';
@Component({
    selector: 'home-edit-an-engagement',
    templateUrl: './home-edit-an-engagement.component.html',
    styleUrls: ['./home-edit-an-engagement.component.scss']
})

export class HomeEditAnEngagementComponent implements OnInit, AfterViewChecked, OnDestroy, RightSideDrawerChildComponent {
    @Input()
    data: any;
    @Output()
    drawerTitle = new EventEmitter<string>();
    RCSWatsonData: any[] = [];
    RCSWatsonDataDup: any[] = [];
    RCSWatsonQuestion = new Map<number, boolean>();
    RCSWatsonvalues = new Map<string, boolean>();
    RCSContractvalues = new Map<string, boolean>();
    enableRCSWatson = false;
    enableRCSContract = false;
    RCSWatsonCount = 0;
    RCSquestiondata: any[] = [];
    RCSContractQuestion = new Map<number, boolean>();
    RCSContractcount = 0;
    noResultflag: boolean;
    questiondata: any;
    RCSContractData: any;
    questiondataContract: any;
    showyesWError = false;
    RCSContractDataDup: any[] = [];
    engagementManager: any;
    engagementPartner: any;
    taxYear: any;
    engagementFlagOptions: EngagementFlagOptions;
    studyFlagOptionId: number | null = null;
    RCSContractTouched: boolean;
    RCSWatsonTouched: boolean;
    noengagementManager = false;
    noengagementPartner = false;
    finalEngagementManagerstrKPMG: string;
    engagementManagerKPMGUser = false;
    finalEngagementPartnerstrKPMG: string;
    engagementPartnerKPMGUser = false;
    engagementManagerSelected: any = [];
    engagementPartnerSelected: any = [];
    engagementManagerSelectedId = 0;
    engagementPartnerSelectedId = 0;
    initialengagementManagerId: any;
    initialengagementPartnerId: any;
    emailReminderText = 'No reminders';
    dropdownWidth = '19em';
    emailReminderOptions: CustomDropDown[] = [];
    canSMEAddProjects: boolean = false;
    canSMEAddEmployees: boolean = false;
    isArchivedStudy = false;

    public childComponent = 0;

    constructor(private _msalService: MsalService, public rightSideDrawerService: RightSideDrawerService,
        public sessionService: SessionService, private _toastrService: ToastrService,
        private _homeEditService: HomeEditAnEngagementService, public datepipe: DatePipe,
        private _createStudyService: CreateStudyService, private _studyLandingService: StudyLandingService,
        public _clientUserService: AdminClientUsersService) {
        this.engagementFlagOptions = new EngagementFlagOptions();
        this.getEmailReminderFrequency();
    }

    getEmailReminderFrequency(): void {
        const emailFrequencies = APP_CONSTANTS.EMAIL_REMINDER_FREQUENCY;
        emailFrequencies.forEach((item, index) => {
            this.emailReminderOptions.push({ id: index, value: item, isDisabled: index === 0 ? true : false });
        });
    }

    onEmailFrequencySelected(selectedOption: CustomDropDown): void {
        if (selectedOption !== null) {
            const emailFrequency = this.emailReminderOptions.find(item => item.id === selectedOption.id);
            this.reminderValue = emailFrequency && emailFrequency.value.includes(selectedOption.id.toString()) ? emailFrequency.id : 0;
            this.isChanged();
        }
    }

    get f() {
        return this.targetForm?.controls;
    }
    emailReminderFrequencyOptions: any = {
        floor: 0,
        ceil: 10,
        getPointerColor: (value: number): string => {
            if (value === 0) {
                return 'red';
            } else {
                return '#28a745';
            }
        }
    };
    targetForm: FormGroup; // specific variable name in template file
    noResults: boolean;
    kpmgUsers: any = [];
    engagement: Engagement;
    engagementUsers: any[] = [];
    engagementSub: Subscription;
    startDateError = false;
    isStartDateSelected = false;
    startDate: Date = null;
    endDate: Date = null;
    engagementId: any;
    clientUsers: any;
    isSearchKPMG = false;
    engagementNumberError = false;
    engagementNameError = false;
    maxDate: Date = new Date(2999, 25, 12);
    clientId: number;
    isReadonlyENo = false;
    @ViewChild('dpStart', { static: true }) dpStart;
    @ViewChild('dpEnd', { static: true }) dpEnd;
    minDate: Date = new Date();
    check = false;
    currentUserEmail: string;
    kpmgUsersSelected: any[] = [];
    clientUsersSelected: any[] = [];
    isDisabled = true;
    kpmgUsersSelectedbckup: any[] = [];
    clientUsersSelectedbckup: any[] = [];
    changed = new Map<string, boolean>();
    adKPMGUser = false;
    adClientUser = false;
    showAddUserModel = false;
    clientName: any;
    keywork = 'Click here';
    hlink = '';
    addUserName = '';
    finalstrClient: string;
    finalstrKPMG: string;
    defaultStartDate: Date = new Date();
    defaultEndDate: Date;
    reminderValue: any;
    demoClientUsers: any;
    engagementData: any[];
    actualreminderFrequencyValue = 0;
    @Output() drawerWidth = new EventEmitter<any>();
    engagementManagerToDisplay = '';
    engagementPartnerToDisplay = '';
    engagementName: string;
    engagementNumber: string;

    isHidden = true;
    isHidden2 = true;
    isRCSWatsonEnabled = false;
    isRCSContractEnabled = false;
    rcsWatsonTitleMessage = 'RCS with Watson to access {0}allowed';
    rcsContractTitleMessage = 'RCS Contract Analysis {0}allowed';

    trimSpecialChar(ctrl: any) {
        this.targetForm.controls[ctrl].setValue(
            this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/ ]/g, '')
        );
    }

    // reset form content
    public resetRightSideDrawerData = () => {
        let endDate = '';
        const rowEditData = this.rightSideDrawerService.singleRowEditData.result;
        this.isArchivedStudy = rowEditData.isArchived;
        this.engagementNumber = rowEditData.engagementNumber;
        this.engagementName = rowEditData.engagementName ? rowEditData.engagementName.trim() : null;
        if (rowEditData.engagementEndDate !== null) {
            endDate = formatDate(
                rowEditData.engagementEndDate,
                'MM/dd/yyyy',
                'en-US'
            );
        }

        this.engagementId = rowEditData.engagementId;
        this.check = rowEditData.isArchived;
        this.targetForm = new FormGroup({
            clientName: new FormControl(
                rowEditData.clientName
                    ? rowEditData.clientName.trim()
                    : null
            ),
            engagementName: new FormControl(this.engagementName),
            engagementManager: new FormControl(this.engagementManagerToDisplay ? this.engagementManagerToDisplay : ''
                , [Validators.required]
            ),
            engagementPartner: new FormControl(this.engagementPartnerToDisplay ? this.engagementPartnerToDisplay : ''
                , [Validators.required]
            ),
            engagementNumber: new FormControl(this.engagementNumber, [Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]),
            engagementStartDate: new FormControl(
                formatDate(
                    rowEditData.engagementStartDate,
                    'MM/dd/yyyy',
                    'en-US'
                ),
                [Validators.required]
            ),
            engagementEndDate: new FormControl(endDate),
            engagementEmailFrequency: new FormControl(
                rowEditData.reminderFrequency,
                Validators.pattern('^([0-9]|1[0-4])$')
            ),
            totalHours: new FormControl(rowEditData.totalHours),
            standardNonWorkingHours: new FormControl(rowEditData.standardNonWorkingHours),
            priorYearQre: new FormControl(rowEditData.priorYearQre),
            estimatedQre: new FormControl(rowEditData.estimatedQre)
        });

        this.actualreminderFrequencyValue = rowEditData.reminderFrequency;
        this.isReadonlyENo = false;

        if (stringNotEmpty(rowEditData.engagementNumber)) {
            this.isReadonlyENo = true;
        }

        this.questiondata = rowEditData.rcsWatsonAnalysis;
        this.questiondataContract = rowEditData.rcsContractAnalysis;
        this.isRCSWatsonEnabled = rowEditData.isRCSWatsonEnabled;
        this.isRCSContractEnabled = rowEditData.isRCSContractAnalysisEnabled;
        this.enableRCSWatson = rowEditData.isRCSWatsonEnabled;
        this.enableRCSContract = rowEditData.isRCSContractAnalysisEnabled;

        if (rowEditData.isArchived) {
            this.targetForm.disable();
        }

        if (!this.rightSideDrawerService.manageClientUserData) {
            this.rightSideDrawerService.manageClientUserData = {
                clientId: this.clientId,
                clientName: rowEditData.clientName ? rowEditData.clientName.trim() : null,
                isManageClientUser: false
            };
        } else if (this.rightSideDrawerService.manageClientUserData.isManageClientUser) {
            this.rightSideDrawerService.manageClientUserData = {
                clientId: this.clientId,
                clientName: rowEditData.clientName ? rowEditData.clientName.trim() : null,
                isManageClientUser: false
            };
            this.childComponent = 1;
        } else {
            this.rightSideDrawerService.manageClientUserData = null;
        }
    };



    onRCSWatsonSelect() {
        this.RCSWatsonTouched = true;
        const questions = this.RCSWatsonData.sort(i => i.questionOrder);
        this.questiondata = questions.filter((elem, index, self) => {
            return index === self.indexOf(elem);
        });
        const uniq = {};
        this.questiondata = questions.filter(obj => !uniq[obj.questionID] && (uniq[obj.questionID] = true));
        this.RCSWatsonQuestion[0] = false;
        this.RCSWatsonQuestion[1] = false;
        this.RCSWatsonQuestion[2] = false;
        this.RCSWatsonCount = 0;
        this.isChanged();
    }


    RCSWatsonChange(ans, index, id) {
        const RCSquestiondata = {
            questionID: id,
            ans: ans
        };

        if (this.RCSquestiondata?.find(x => x.questionID === id)) {
            this.RCSquestiondata.find(x => x.questionID == id).ans = ans;
        } else {
            this.RCSquestiondata.push(RCSquestiondata);
        }

        this.RCSWatsonData = copyObject(this.RCSWatsonDataDup);
        if (ans === 'yes') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = false;
            const message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'Yes');
            this.RCSWatsonQuestion[index] = true;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;
        }

        if (ans === 'no') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = true;
            const message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'No');
            this.RCSWatsonQuestion[index] = false;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;
        }

        if (ans === 'notsure') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = false;
            const message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'NotSure');
            this.RCSWatsonQuestion[index] = true;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;
        }

        this.determineRCSEnable();
    }


    determineRCSEnable() {
        if (this.RCSWatsonvalues['3'] === true && this.RCSWatsonvalues['1'] === true && this.RCSWatsonCount === 3) {
            this.enableRCSWatson = true;
        } else if (this.RCSWatsonvalues['3'] === false || this.RCSWatsonvalues['1'] === false) {
            this.enableRCSWatson = false;
        }
        this.isChanged();
    }


    // RCS contract
    onRCSContractSelect() {
        this.RCSContractTouched = true;
        const questions = this.RCSContractData.sort(i => i.questionOrder);
        this.questiondataContract = questions.filter((elem, index, self) => {
            return index === self.indexOf(elem);
        });
        const uniq = {};
        this.questiondataContract = questions.filter(obj => !uniq[obj.questionID] && (uniq[obj.questionID] = true));
        this.RCSContractQuestion[0] = false;
        this.RCSContractQuestion[1] = false;
    }


    RCSContractChange(ans, index, id) {
        const RCSquestiondata = {
            questionID: id,
            ans: ans
        };

        if (this.RCSquestiondata?.find(x => x.questionID === id)) {
            this.RCSquestiondata.find(x => x.questionID == id).ans = ans;
        } else {
            this.RCSquestiondata.push(RCSquestiondata);
        }

        this.RCSContractData = copyObject(this.RCSContractDataDup);
        if (ans === 'yes') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = false;
            const message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'Yes');
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;
        }

        if (ans === 'no') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = true;
            const message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'No');
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;
        }

        if (ans === 'notsure') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = false;
            const message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'NotSure');
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;
        }
        this.determineRCSContractEnable();
    }


    determineRCSContractEnable() {
        if (this.RCSContractvalues['4'] === true && this.RCSContractcount === 2) {
            this.enableRCSContract = true;
        } else if (this.RCSContractcount === 2) {
            this.enableRCSContract = false;
        }
        this.isChanged();
    }

    isChanged() {
        const enddate = this.endDate
            ? formatDate(this.endDate, 'MM/dd/yyyy', 'en-US')
            : this.endDate;
        const rowEditData = this.rightSideDrawerService.singleRowEditData.result;
        const enddateoriginal = rowEditData.engagementEndDate
            ? formatDate(rowEditData.engagementEndDate,
                'MM/dd/yyyy',
                'en-US'
            )
            : rowEditData.engagementEndDate;
        if (this.check !== rowEditData.isArchived && this.isArchivedStudy) {
            this.isDisabled = false;
            this.targetForm.enable();
        } else if (this.changed['KPMG'] || this.changed['client']) {
            this.isDisabled = false;
            this.rightSideDrawerService.setMandatoryField(true, 'Edit Study');
        } else if (
            this.reminderValue !== rowEditData.reminderFrequency
            || (this.startDate &&
                formatDate(this.startDate, 'MM/dd/yyyy', 'en-US') !==
                formatDate(rowEditData.engagementStartDate, 'MM/dd/yyyy', 'en-US'))
            || enddate !== enddateoriginal
            || this.check !== rowEditData.isArchived
            || (this.RCSWatsonTouched && this.RCSWatsonCount == 3)
            || (this.RCSContractTouched && this.RCSContractcount == 2)) {
            this.isDisabled = false;
            this.rightSideDrawerService.setMandatoryField(true, 'Edit Study');
        } else if (
            (this.engagementManagerSelectedId > 0 && this.engagementManagerSelectedId != this.initialengagementManagerId) &&
            (this.engagementPartnerSelectedId > 0 && this.engagementPartnerSelectedId != this.initialengagementPartnerId)) {
            this.isDisabled = false;
            this.rightSideDrawerService.setMandatoryField(true, 'Edit Study');
        } else {
            this.isDisabled = true;
            this.rightSideDrawerService.setMandatoryField(false, '');
        }
    }

    masterCheckboxaction = event => {
        if (event === true) {
            this.check = event;
        } else {
            this.check = false;
        }
        this.isChanged();
    };

    getReminderFrequency(event: any) {
        this.reminderValue = event.target.selectedIndex === 0 ? 0 : event.target[event.target.selectedIndex].Value;
        this.isChanged();
    }

    engagementInputChange() {
        if (
            this.targetForm.get('engagementManager').value !==
            this.rightSideDrawerService.singleRowEditData.result.engagementManager
            || this.targetForm.get('engagementPartner').value !==
            this.rightSideDrawerService.singleRowEditData.result.engagementPartner
        ) {
            this.isDisabled = false;
            this.rightSideDrawerService.setMandatoryField(true, 'Edit Engagement');
        } else {
            this.isDisabled = true;
            this.rightSideDrawerService.setMandatoryField(false, '');
        }
        this.isChanged();
    }

    updateEngagement() {
        this.rightSideDrawerService.spinnerLoad(true);
        this.isDisabled = true;
        this.kpmgUsersSelected.forEach((kpmgUsers: any) => {
            this.engagementUsers.push(kpmgUsers);
        });

        this.clientUsersSelected.forEach((clientUsers: any) => {
            this.engagementUsers.push(clientUsers);
        });

        const engagement = {
            engagementId: this.engagementId,
            engagementNumber: encodeText(this.targetForm.get('engagementNumber').value),
            engagementName: encodeText(this.targetForm.get('engagementName').value),
            updatedOn: new Date(),
            engagementStartDate: this.datepipe.transform(
                this.targetForm.get('engagementStartDate').value,
                'MM/dd/yyyy'
            ),
            engagementEndDate: this.targetForm.get('engagementEndDate').value
                ? this.datepipe.transform(
                    this.targetForm.get('engagementEndDate').value,
                    'MM/dd/yyyy'
                )
                : null,
            reminderFrequency: this.reminderValue,
            users: this.engagementUsers,
            updatedBy: this.rightSideDrawerService.singleRowEditData.result.updatedBy,
            isArchived: this.check,
            RCSDocumentAnalysis: this.RCSquestiondata,
            RCSWatson: this.enableRCSWatson,
            RCSContract: this.enableRCSContract,
            engagementManager: this.engagementManagerSelectedId,
            engagementPartner: this.engagementPartnerSelectedId,
            taxYear: this.taxYear,
            engagementFlagId: this.studyFlagOptionId,
            clientId: this.clientId,
            totalHours: this.targetForm.get('totalHours').value,
            standardNonWorkingHours: this.targetForm.get('standardNonWorkingHours').value,
            canSMEAddProjects: this.canSMEAddProjects,
            canSMEAddEmployees: this.canSMEAddEmployees,
            priorYearQre: this.targetForm.get('priorYearQre').value !== null ? this.targetForm.get('priorYearQre').value : 0,
            estimatedQre: this.targetForm.get('estimatedQre').value !== null ? this.targetForm.get('estimatedQre').value : 0
        };

        this._homeEditService.UpdateEngagement(engagement).subscribe(
            (data: BaseResponse) => {
                if (data !== null && data.success) {
                    this.rightSideDrawerService.spinnerLoad(false);
                    this.targetForm.reset();
                    this._homeEditService.refreshHomeTable();
                    this._studyLandingService.refreshStudyYear(this.taxYear);
                    this._studyLandingService.refreshStudyFlagId(this.studyFlagOptionId);
                    this._studyLandingService.refresPriorYearQREs(engagement.priorYearQre);
                    this._studyLandingService.refreshEstimatedQREs(engagement.estimatedQre);
                    this.rightSideDrawerService.closeRightSideDrawer();
                    this._toastrService.setSuccessMessage(
                        Messages.Home.UpdateEngagementSuccess
                    );

                    this.sessionService.setEngagementName(decodeText(engagement.engagementName));
                    this.sessionService.setEngagementNumber(decodeText(engagement.engagementNumber));
                    this.sessionService.setEngagementNameAndNumber(decodeText(engagement.engagementName), decodeText(engagement.engagementNumber.toString()))
                } else {
                    this.isDisabled = true;
                    this._toastrService.setErrorMessage(
                        Messages.Home.UpdateEngagementFailure
                    );
                }
            });
    }

    // check if engagement number already exists
    checkEngagementNumber() {
        const engagementNumber = this.targetForm.get('engagementNumber').value || '';
        if (engagementNumber) {
            this._homeEditService
                .CheckEngagementNumber(engagementNumber)
                .subscribe((data: BaseResponse) => {
                    this.engagementNumberError = data.result;
                    this.isDisabled = data.result;
                });
        }
    }

    ngOnInit() {
        const user = this._msalService.instance.getActiveAccount();
        this.sessionService.setSession('userEmail', user.username);

        this.engagementSub = this._homeEditService.engagementRefresh.subscribe((data: any) => {
            if (data) {
                this.engagement = data.result;
                this.rightSideDrawerService.singleRowEditData = data;
                this.clientId = this.rightSideDrawerService.singleRowEditData.result.clientId;
                const engagementManagerId = this.rightSideDrawerService.singleRowEditData.result.engagementManager;
                this.initialengagementManagerId = engagementManagerId;
                this.engagementManagerSelectedId = engagementManagerId;
                const engagementPartnerId = this.rightSideDrawerService.singleRowEditData.result.engagementPartner;
                this.initialengagementPartnerId = engagementPartnerId;
                this.engagementPartnerSelectedId = engagementPartnerId;
                this.studyFlagOptionId = this.getStudyFlagOptionId(data.result.engagementFlagId);
                this.emailReminderText = this.rightSideDrawerService.singleRowEditData.result.reminderFrequency === 0 ?
                    'No reminders' : this.emailReminderOptions[this.rightSideDrawerService.singleRowEditData.result.reminderFrequency].value;
                this._createStudyService.kpmgUsersDataSource$.subscribe(users => {
                    if (users && users.result) {
                        this.kpmgUsers = users;
                        const engagementManager = this.kpmgUsers.result.filter(x => x.userId === +engagementManagerId);
                        const engagementPartner = this.kpmgUsers.result.filter(x => x.userId === +engagementPartnerId);
                        this.engagementManagerToDisplay = engagementManager && engagementManager[0] ? engagementManager[0].displayName : ''; // + " - " +engagementManager[0].email 
                        this.engagementPartnerToDisplay = engagementPartner && engagementPartner[0] ? engagementPartner[0].displayName : ''; // + " - " +engagementPartner[0].email
                        if (this.engagementManagerToDisplay === '') {
                            this.noengagementManager = true;
                        }
                        if (this.engagementManagerToDisplay === '') {
                            this.noengagementPartner = true;
                        }
                        this.targetForm?.controls.engagementManager.setValue(this.engagementManagerToDisplay);
                        this.targetForm?.controls.engagementPartner.setValue(this.engagementPartnerToDisplay);
                    }
                });
                this.getClientUsers(this.clientId);
                this.resetRightSideDrawerData();
                this.bindUsers(
                    this.rightSideDrawerService.singleRowEditData.result.users
                );
            }
        });
        // this.getKPMGUsers();
        this.currentUserEmail = this.sessionService.getSession('userEmail');
        this.changed['KPMG'] = false;
        this.changed['client'] = false;
        this.defaultStartDate = new Date(
            this.rightSideDrawerService.singleRowEditData.result.engagementStartDate
        );

        if (this.rightSideDrawerService.singleRowEditData.result.engagementEndDate) {
            this.defaultEndDate = new Date(this.rightSideDrawerService.singleRowEditData.result.engagementEndDate);
        } else {
            this.defaultEndDate = null;
        }

        this.reminderValue = this.rightSideDrawerService.singleRowEditData.result.reminderFrequency;
        this.engagementManager = this.rightSideDrawerService.singleRowEditData.result.engagementManager;
        this.engagementPartner = this.rightSideDrawerService.singleRowEditData.result.engagementPartner;
        this.taxYear = this.rightSideDrawerService.singleRowEditData.result.taxYear;
        this.canSMEAddProjects = this.rightSideDrawerService.singleRowEditData.result.canSMEAddProjects;
        this.canSMEAddEmployees = this.rightSideDrawerService.singleRowEditData.result.canSMEAddEmployees;
        this.drawerWidth.emit('calc(61vw - 100px)');
        this.drawerTitle.emit(this.rightSideDrawerService.singleRowEditData.result.engagementName);
    }

    drawerWidthHandler(width: string) {
        this.drawerWidth.emit(width);
    }

    ngAfterViewChecked() {
        // Refresh form inputs if drawer is opened or loaded.
        if (this.rightSideDrawerService.triggerRightSideDrawerClick) {
            // this.resetRightSideDrawerData();
            this.rightSideDrawerService.triggerRightSideDrawerClick = false; // Set trigger to false so that this action is only performed once. Without this, the form would keep resetting on every change on any input.
        }
    }

    ngOnDestroy() {
        this.engagementSub.unsubscribe();
    }

    private getStudyFlagOptionId(id: number) {
        if (id && id >= 1 && id <= 3) {
            return id;
        } else {
            return this.studyFlagOptionId = null;
        }
    }

    // KPMG Users
    getKPMGUsers() {
        this._homeEditService.GetKPMGUsers().subscribe(
            data => {
                this.kpmgUsers = data;
            });
    }

    getClientUsers(clientId: number) {
        this._homeEditService.GetClientUsers(clientId).subscribe(
            (data: any) => {
                this.clientUsers = data.result;
            });
    }

    private searchKPMGUsers(term: any): Observable<any> {
        if (this.kpmgUsers.result) {
            return of(
                this.kpmgUsers.result.filter(
                    item =>
                        item.displayName != null && item.displayName.toLowerCase().includes(term.toLowerCase()) ||
                        item.userName != null && item.userName.toLowerCase().includes(term.toLowerCase()) ||
                        item.email != null && item.email.toLowerCase().includes(term.toLowerCase())
                )
            );
        } else {
            return of([]);
        }
    }

    private searchClientUsers(term: any): Observable<any> {
        if (this.clientUsers) {
            return of(
                this.clientUsers.filter(
                    item =>
                        item.displayName != null && item.displayName.toLowerCase().includes(term.toLowerCase()) ||
                        item.userName != null && item.userName.toLowerCase().includes(term.toLowerCase()) ||
                        item.email != null && item.email.toLowerCase().includes(term.toLowerCase())
                )
            );
        } else {
            return of([]);
        }
    }

    private searchDemoClientUsers(term: any): Observable<any> {
        if (this.kpmgUsers.result || this.clientUsers) {
            const kpmgUserdata: any[] = this.kpmgUsers.result;
            const clientUserData: any[] = this.clientUsers;
            this.demoClientUsers = kpmgUserdata.concat(clientUserData);
            if (kpmgUserdata != null && clientUserData != null) {
                return of(
                    this.demoClientUsers.filter(
                        item =>
                            item.displayName != null && item.displayName.toLowerCase().includes(term.toLowerCase()) ||
                            item.userName != null && item.userName.toLowerCase().includes(term.toLowerCase()) ||
                            item.email != null && item.email.toLowerCase().includes(term.toLowerCase())
                    )
                );
            } else if (kpmgUserdata != null && clientUserData == null) {
                return of(
                    kpmgUserdata.filter(
                        item =>
                            item.displayName != null && item.displayName.toLowerCase().includes(term.toLowerCase()) ||
                            item.userName != null && item.userName.toLowerCase().includes(term.toLowerCase()) ||
                            item.email != null && item.email.toLowerCase().includes(term.toLowerCase())
                    )
                );
            } else {
                return of(
                    clientUserData.filter(
                        item =>
                            item.displayName != null && item.displayName.toLowerCase().includes(term.toLowerCase()) ||
                            item.userName != null && item.userName.toLowerCase().includes(term.toLowerCase()) ||
                            item.email != null && item.email.toLowerCase().includes(term.toLowerCase())
                    )
                );
            }
        } else {
            return of([]);
        }
    }

    searchKPMG(bool: boolean) {
        this.isSearchKPMG = bool;
    }

    searchUserStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                this.finalstrKPMG = '';
                this.finalstrClient = '';
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered
                    const str1 = 'Click here to add user.';
                    this.finalstrKPMG =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();

                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {
                            const noData = [
                                {
                                    email: null,
                                    isDelete: false,
                                    userName: this.finalstrKPMG
                                }
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.adKPMGUser = true;
                                this.addUserName = term;
                                return of(noData);
                            } else {
                                this.adKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.clientName !== 'KPMG Demo'
                ) {
                    const str2 = 'Click here to add user.';
                    this.finalstrClient =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str2.italics();
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            const noData = [
                                {
                                    email: null,
                                    userName: this.finalstrClient
                                }
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.adClientUser = true;
                                this.addUserName = term;
                                return of(noData);
                            } else {
                                this.adClientUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.clientName === 'KPMG Demo'
                ) {
                    const str2 = 'Click here to add user.';
                    this.finalstrClient =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str2.italics();
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            const noData = [
                                {
                                    email: null,
                                    userName: this.finalstrClient
                                }
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.adClientUser = true;
                                this.addUserName = term;
                                return of(noData);
                            } else {
                                this.adClientUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else {
                    return of([]);
                }
            })
        );

    kpmgUserFormatter = (result: any) => '';
    clientUserFormatter = (result: any) => '';

    setStartDate(date: Date) {
        this.startDate = date;
        this.minDate = date;
        this.taxYear = this.startDate && this.isStartDateSelected ? this.startDate.getFullYear() : this.engagement.taxYear;

        this.isChanged();
        if (this.startDate && this.endDate) {
            this.checkValidDates();
        }
        this.isStartDateSelected = true;
    }

    setEndDate(date: Date) {
        this.endDate = date;
        this.isChanged();
        if (this.startDate && this.endDate) {
            this.checkValidDates();
        }
    }

    // Validate start date isn't greater than end date if end date is specified
    checkValidDates() {
        const startDateConverted = new Date(this.startDate);
        const endDateConverted = new Date(this.endDate);

        if (startDateConverted > endDateConverted) {
            this.targetForm.controls['engagementEndDate'].setErrors({
                incorrect: true
            });
            this.startDateError = true;
        } else {
            this.startDateError = false;
        }
    }

    onfocStartDate() {
        setTimeout(() => {
            this.dpStart?.show();
        }, 100);
    }

    onfocEndDate() {
        setTimeout(() => {
            this.dpEnd?.show();
            this.dpStart.hide();
        }, 100);
    }

    onfocEF() {
        this.dpEnd.hide();
    }

    // On KPMG user selection
    onKPMGUserSelect($event: any) {
        const user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            // this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsFromEditStudy(true);
        } else {
            const engagementUser = {
                userId: user.userId,
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                roleId: role.admin,
                clientId: user.clientId
            };

            const index = this.kpmgUsersSelected.findIndex(
                item => item.userId === engagementUser.userId
            );
            if (index !== -1) {
                return;
            }
            // let checker = (this.kpmgUsersSelected, this.kpmgUsersSelectedbckup) => this.kpmgUsersSelectedbckup.every(v => this.kpmgUsersSelected.includes(v));

            this.kpmgUsersSelected.push(engagementUser);
            this.sortedUsers();
            this.kpmgUsersSelected = [...this.kpmgUsersSelected];
            const comparator = function (a, b) {
                return a.userId === b.userId;
            };

            const found = this.kpmgUsersSelectedbckup.some(
                el => el.userId === engagementUser.userId
            );
            if (
                found &&
                this.kpmgUsersSelectedbckup.length === this.kpmgUsersSelected.length
            ) {
                // this.isDisabled=true;
                this.changed['KPMG'] = false;
            } else {
                // this.isDisabled=false;
                this.changed['KPMG'] = true;
            }
            this.isChanged();
        }
    }

    removeKPMGUser(row: any) {
        const removeIndex = this.kpmgUsersSelected.findIndex(
            item => item.userId === row.userId
        );
        this.kpmgUsersSelected.splice(removeIndex, 1);
        this.kpmgUsersSelected = [...this.kpmgUsersSelected];
        const found1 = this.kpmgUsersSelectedbckup.some(
            val => this.kpmgUsersSelected.indexOf(val) !== -1
        );

        let found = true;
        this.kpmgUsersSelectedbckup.forEach(element => {
            if (!this.kpmgUsersSelected.some(el => el.userId === element.userId)) {
                found = false;
            }
        });

        if (
            found &&
            this.kpmgUsersSelectedbckup.length === this.kpmgUsersSelected.length
        ) {
            // this.isDisabled=true;
            this.changed['KPMG'] = false;
        } else {
            // this.isDisabled=false;
            this.changed['KPMG'] = true;
        }
        this.isChanged();
    }

    // On KPMG user selection
    onClientUserSelect($event: any) {
        const user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            this.clientName = user.clientName;
            this._clientUserService.setFunctionTypeAndData(true, true);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsFromEditStudy(true);
        } else {
            const engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.clientManager
            };

            const index = this.clientUsersSelected.findIndex(
                item => item.userId === engagementUser.userId
            );
            if (index !== -1) {
                return;
            }

            this.clientUsersSelected.push(engagementUser);
            this.clientUsersSelected = [...this.clientUsersSelected];

            const found = this.clientUsersSelectedbckup.some(
                el => el.userId === engagementUser.userId
            );

            if (
                found &&
                this.clientUsersSelectedbckup.length === this.clientUsersSelected.length
            ) {
                // this.isDisabled=true;
                this.changed['client'] = false;
            } else {
                // this.isDisabled=false;
                this.changed['client'] = true;
            }
            this.isChanged();
        }
    }

    removeClientUser(row: any) {
        const removeIndex = this.clientUsersSelected.findIndex(
            item => item.userId === row.userId
        );
        this.clientUsersSelected.splice(removeIndex, 1);
        this.clientUsersSelected = [...this.clientUsersSelected];

        let found = true;
        this.clientUsersSelectedbckup.forEach(element => {
            if (!this.clientUsersSelected.some(el => el.userId === element.userId)) {
                found = false;
            }
        });

        if (
            found &&
            this.clientUsersSelectedbckup.length === this.clientUsersSelected.length
        ) {
            this.changed['client'] = false;
        } else {
            // this.isDisabled=false;
            this.changed['client'] = true;
        }
        this.isChanged();
    }

    // bindUsers
    bindUsers(users: any) {
        users.forEach((user: any) => {
            if (user.roleId === role.admin) {
                this.kpmgUsersSelected.push(user);
                this.kpmgUsersSelectedbckup.push(user);
            } else if (user.roleId === role.clientManager) {
                this.clientUsersSelected.push(user);
                this.clientUsersSelectedbckup.push(user);
            }
        });
        this.sortedUsers();
    }

    sortedUsers() {
        this.kpmgUsersSelected = this.kpmgUsersSelected.sort((a, b) =>
            a.userName > b.userName ? 1 : -1
        );
    }

    flagOptionClick(optionId: number) {
        this.isDisabled = false;
        this.studyFlagOptionId = optionId;
    }
    onHoursChanged() {
        const maxTotalhours: number = 3500;
        const maxStandardNWH: number = 2096;
        this.isDisabled = (this.targetForm.controls.totalHours.value > maxTotalhours || this.targetForm.controls.standardNonWorkingHours.value > maxStandardNWH);
    }

    onQreChanged() {
        this.isDisabled = false;
    }

    openDatePickerEnd() {
        if (this.check) {
            return;
        }
        this.dpEnd.toggle();
    }

    openDatePickerStart() {
        if (this.check) {
            return;
        }
        this.dpStart.toggle();
    }

    clearStartDate() {
        this.targetForm.controls.engagementStartDate.setValue(null);
    }

    clearEndDate() {
        this.targetForm.controls.engagementEndDate.setValue(null);
    }

    bindNewuser(user: any) {
        if (user.clientId === null) {
            const engagementUser = {
                userId: user.userId,
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                roleId: role.admin,
                clientId: user.clientId
            };
            this.kpmgUsersSelected.push(engagementUser);
            this.sortedUsers();
            this.kpmgUsersSelected = [...this.kpmgUsersSelected];
            this.changed['KPMG'] = true;
        } else {
            const engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.clientManager
            };

            this.clientUsersSelected.push(engagementUser);
            this.clientUsersSelected = [...this.clientUsersSelected];
            this.changed['client'] = true;
        }
        this.isChanged();
    }

    // sliderEvent(changeContext: ChangeContext) {
    //     if (this.actualreminderFrequencyValue !== changeContext.value) {
    //         this.isDisabled = false;
    //     } else {
    //         this.isDisabled = true;
    //     }
    //     this.reminderValue = this.targetForm.get('engagementEmailFrequency').value;
    // }

    addUserClick = () => {
        if (this.check) {
            return;
        }
        this._clientUserService.setFunctionTypeAndData(false, true, null);
        this.rightSideDrawerService.openRightSideDrawer('add-user-form');
        this.rightSideDrawerService.setIsFromEditStudy(true);
    }

    // Search EngagementPartner
    searchEngagementPartnerStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                this.finalEngagementPartnerstrKPMG = '';
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered

                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {

                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                const str1 = 'Click here to add user.';
                                this.finalEngagementPartnerstrKPMG = 'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                                const noData = [
                                    {
                                        email: null,
                                        isDelete: false,
                                        userName: this.finalEngagementPartnerstrKPMG
                                    }
                                ];
                                this.engagementPartnerKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementPartnerKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.clientName !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.clientName === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            })
        );

    // On Engagement Partner selection
    onEngagementPartnerSelect($event: any) {
        const user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            // this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromEditStudy(true);
        } else {
            this.engagementPartnerSelectedId = user.userId;
            const engagementUser = {
                userName: user.userName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.admin
            };
            this.engagementPartnerSelected = [];
            this.engagementPartnerSelected.push(engagementUser);
        }
        this.isChanged();
    }

    removeEngagementPartnerSelected(row: any) {
        this.engagementPartnerSelectedId = 0;
        const removeIndex = this.engagementPartnerSelected.findIndex(
            item => item.userId === row.userId
        );
        this.engagementPartnerSelected.splice(removeIndex, 1);
        this.engagementPartnerSelected = [...this.engagementPartnerSelected];
        this.isChanged();
    }

    onEngagementManagerSelect($event: any) {
        const user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromEditStudy(true);
        } else {
            const user = $event.item;
            this.engagementManagerSelectedId = user.userId;
            const engagementUser = {
                userName: user.userName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.admin
            };
            this.engagementManagerSelected = [];
            this.engagementManagerSelected.push(engagementUser);
        }
        this.isChanged();
    }

    removeEngagementManagerSelected(row: any) {
        this.engagementManagerSelectedId = 0;
        const removeIndex = this.engagementManagerSelected.findIndex(
            item => item.userId === row.userId
        );
        this.engagementManagerSelected.splice(removeIndex, 1);
        this.engagementManagerSelected = [...this.engagementManagerSelected];
        this.isChanged();
    }

    // Search Engagement manager Search Stream
    searchEngagementManagerStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                this.finalEngagementManagerstrKPMG = '';
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered
                    const str1 = 'Click here to add user.';
                    this.finalEngagementManagerstrKPMG =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {
                            const noData = [
                                {
                                    email: null,
                                    isDelete: false,
                                    userName: this.finalEngagementManagerstrKPMG
                                }
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.engagementManagerKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementManagerKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.clientName !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.clientName === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            })
        );

    allowSMEsToAddNewProjectsEvent(checked: boolean) {
        this.canSMEAddProjects = checked
        this.isDisabled = false;
    }

    allowSMEsToAddNewEmployeesEvent(checked: boolean) {
        this.canSMEAddEmployees = checked
        this.isDisabled = false;
    }

    onChangeEngagementName(engagementName: string) {
        if (!(engagementName?.trim()?.length > 0)) {
            this.engagementNameError = true;
            this.isDisabled = true;
        } else {
            this.engagementNameError = false;
            this.isDisabled = false;
        }
    }
    onChangeEngagementNumber(engagementNumber: string) {
        if (!(engagementNumber?.trim()?.length > 0)) {
            this.engagementNumberError = true;
            this.isDisabled = true;
        } else {
            this.engagementNumberError = false;
            this.isDisabled = false;
        }
    }

    loadChildComponent(childComponent: any): void {
        this.childComponent = childComponent
        if (childComponent === 0) {
            this.drawerWidth.emit('calc(61vw - 100px)');
        }
    }
}
